<template>
    <div class="AboutPageContainer">
        <div class="container">
            <InfoCard img="/local/templates/main/img/content/article-2.jpg">
                <h3>Как я решил стать волонтером "Интеллектуальной </h3>
                <p>Много лет поддерживая разные некоммерческие организации и отдельных людей, друзья пришли к выводу,
                    что отрасли нужны системные изменения.</p>

                <p> Благотворительный фонд «DOS» основали три друга: Гор Нахапетян, Ян Яновский и Дмитрий Ямпольский в
                    2015 году.</p>

                <p> Благотворительный фонд «DOS» основали три друга: Гор Нахапетян, Ян Яновский и Дмитрий Ямпольский в
                    2015 году. </p>
            </InfoCard>

            <InfoCard img="/local/templates/main/img/content/article-3.jpg" :ltr="false">
                <h3>Целый мир внештатных талантов в ваших руках</h3>
                <ul>
                    <li><b>Качественно выполненная работа быстро</b>
                        Найдите подходящего фрилансера, чтобы начать работу над вашим проектом в течение нескольких
                        минут.
                    </li>

                    <li><b>Защищенные платежи, каждый раз</b>
                        Всегда знайте, что вы будете платить заранее. Ваш платеж не будет разблокирован, пока вы не
                        одобрите работу.
                    </li>
                    <li><b> Круглосуточная поддержка</b>

                        Вопросы? Наша круглосуточная служба поддержки готова помочь в любое время и в любом месте.
                    </li>
                </ul>
            </InfoCard>

            <IconCardsSection title="Наши цели" :params="params.iconCards"/>

            <HelpSection :params="params.helpSection"/>

            <StoriesSliderSection :params="params.stories"/>

            <TeamSection :params="params.teamSection"/>

            <PartnersSliderSection :params="params.partners"/>

            <section class="banner" :style="`background-image: url('${params.banner.background}')`"
                     v-if="params.banner">
                <div class="banner__in">
                    <div class="banner__title">{{ params.banner.title }}</div>
                    <div class="banner__description">{{ params.banner.description }}</div>
                    <a class="banner__button" :href="params.banner.buttonUrl">
                        <ABtn color="#fff" fill="#000" class=" dark" :label="params.banner.buttonText"/>
                    </a>
                </div>
            </section>

            <ArticlesSection :params="params.articles"/>

            <NumbersSection :items="params.numbers"/>

        </div>
    </div>
</template>

<script>
import {ABtn} from "../components/ui";
import InfoCard from "../components/cards/InfoCard";
import IconCardsSection from "../components/sections/IconCardsSection";
import HelpSection from "../components/sections/HelpSection";
import TeamSection from "../components/sections/TeamSection";
import StoriesSliderSection from "../components/sections/StoriesSliderSection";
import ArticlesSection from "../components/sections/ArticlesSection";
import NumbersSection from "../components/Numbers/NumbersSection";
import PartnersSliderSection from "../components/sections/PartnersSliderSection";

export default {
    name: "AboutPageContainer",
    props: ['params'],
    components: {
        PartnersSliderSection,
        NumbersSection,
        ArticlesSection, StoriesSliderSection, TeamSection, HelpSection, IconCardsSection, InfoCard, ABtn
    },
    mounted() {
        document.querySelector('body').classList.add('AboutPageContainerWrapper')
    }
}
</script>
<style lang="scss">
.AboutPageContainerWrapper {
    background-color: #fff !important;

    .page-hero {
        background-color: #EFEFF1;
    }
}
</style>
<style scoped lang="scss">
.banner {
    background-size: cover;
    color: #fff;
    margin: 55px 0;
    width: 100%;

    &__in {
        padding: 50px 60px;
        max-width: 50%;

        @include tablet {
            max-width: 100%;
        }
    }

    &__title {
        font-weight: 600;
        font-size: 40px;
        line-height: 44px;
        margin-bottom: 20px;
    }

    &__description {
        font-weight: 400;
        font-size: 16px;
        line-height: 26px;
        margin-bottom: 36px;
    }
}
</style>